import { Box } from '@mui/material';
import { GridAutoColumnChart } from '../../styles/customStyles/customStyles';
import React from 'react'
import ReactApexChart from 'react-apexcharts';
import styled from '@emotion/styled';
const Charts = (props) => {
  const {card_data} = props;

    const series = [{
        name: 'Cases',
        data: card_data?.firstGraphs?.valuesToDisplay
      }];

      const options = {
        chart: {
          type: 'bar',
          height: 300,
          width: 500,
        },
        title: {
            text: 'Total Cases Vs Foot Care Vs Diabetic Retinopathy',
            style: {
              fontSize:  '18px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#000000DE'
            },
          },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '10%',
            barHeight: '70%'
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: card_data?.firstGraphs?.categories,
        },
        fill:{
        colors: [
          function ({ value, seriesIndex, dataPointIndex, w }) {
            if (dataPointIndex === 0) {
              return "#d2980d";
            } else if (dataPointIndex === 1) { 
              return "#786028";
            }
            else if (dataPointIndex === 2) { 
              return "#363445";
            } else {
                return "#438ADD";
              }
            }
        ],
        }
      };


      const series9 = [{
        name: 'Cases',
        data: card_data?.seventhGraphs?.valuesToDisplay
      }];

      const options9 = {
        chart: {
          type: 'bar',
          height: 500,
          width: 800,
        },
        title: {
            text: 'Foot Care Risk Rating',
            style: {
              fontSize:  '18px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              // color:  '#6366F1'
              color:  '#000000DE'
            },
          },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '25%',
            barHeight: '70%'
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: card_data?.seventhGraphs?.categories,
        },
        colors: [
          function ({ value, seriesIndex, dataPointIndex, w }) {
            if (dataPointIndex === 0) {
              return "#d2980d";
            } else if (dataPointIndex === 1) { 
              return "#786028";
            }
            else if (dataPointIndex === 2) { 
              return "#363445";
            }
            else if (dataPointIndex === 3) { 
              return "#48446e";
            }
            else if (dataPointIndex === 4) { 
              return "#5e569b";
            }
             else {
              return "#9080ff";
            }
            }
        ]
      };


      const series10 = [{
        name: 'Cases',
        data: card_data?.eighthGraphs?.valuesToDisplay 
      }];

      const options10 = {
        chart: {
          type: 'bar',
          height: 500,
          width: 800,
        },
        title: {
            text: 'Diabetic Retinopathy Risk Rating',
            style: {
              fontSize:  '18px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              // color:  '#6366F1'
              color:  '#000000DE'
            },
          },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '25%',
            barHeight: '70%'
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: card_data?.eighthGraphs?.categories,
        },
        colors: [
          function ({ value, seriesIndex, dataPointIndex, w }) {
              if (dataPointIndex === 0) {
                return "#d2980d";
              } else if (dataPointIndex === 1) { 
                return "#786028";
              }
              else if (dataPointIndex === 2) { 
                return "#363445";
              }
              else if (dataPointIndex === 3) { 
                return "#48446e";
              }
              else if (dataPointIndex === 4) { 
                return "#5e569b";
              }
               else {
                return "#9080ff";
              }
            }
        ]
      };

      // graph 2
      const series2 = [{
        name: 'Cases',
        data: card_data?.secondGraphs?.valuesToDisplay 
      }];
    
      const options2 = {
        chart: {
          type: 'bar',
          height: 150
        },
        title: {
            text: 'Total Cases Vs Referred Cases',
            style: {
              fontSize:  '18px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              // color:  '#6366F1'
              color:  '#000000DE'
            },
          },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '15%',
            barHeight: '70%'
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: card_data?.secondGraphs?.categories,
        },
        colors: [
          function ({ value, seriesIndex, dataPointIndex, w }) {
            if (dataPointIndex === 0) {
              return "#d2980d";
            } else if (dataPointIndex === 1) { 
              return "#786028";
            }
            else if (dataPointIndex === 2) { 
              return "#363445";
            }
            else if (dataPointIndex === 3) { 
              return "#48446e";
            } else {
                return "#007bff";
              }
            }
        ] 
      };

     
      const series4 = card_data?.fifthGraphs?.valuesToDisplay; 

      const options4 = {
        chart: {
          type: 'pie',
        },
        title: {
            text: 'Foot Care Cases',
            style: {
              fontSize:  '18px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              // color:  '#6366F1'
              color:  '#000000DE'
            },
          },
        labels: card_data?.fifthGraphs?.categories,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        colors:['#d2980d', '#786028', '#363445'],
        grid: {
          row: {
            colors: ['#d2980d', '#786028', '#363445']
          },
          column: {
            colors: ['#d2980d', '#786028', '#363445']
          }
        }
      };

      const series5 = card_data?.sixthGraphs?.valuesToDisplay; // Replace with your actual data

      const options5 = {
    chart: {
      type: 'pie',
    },
    title: {
        text: 'Diabetic Retinopathy',
        style: {
          fontSize:  '18px',
          fontWeight:  'bold',
          fontFamily:  undefined,
          // color:  '#6366F1'
          color:  '#000000DE'
        },
      },
    labels: card_data?.sixthGraphs?.categories,
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 100,
          height:100
        },
        legend: {
          position: 'bottom'
        }
      }
    }],
    colors:['#d2980d', '#786028', '#363445'],
        grid: {
          row: {
            colors: ['#d2980d', '#786028', '#363445']
          },
          column: {
            colors: ['#d2980d', '#786028', '#363445']
          }
    }
       };

  const ChartWrapper = styled(Box)(({theme})=>({
    backgroundColor: theme.palette.grey[200],
    padding: "1rem"
  }))


  // 3rd graph
   const columnBarRegions2nd = {
    series: [
      {
        name: 'Total Cases',
        data: card_data?.thiredGraphs?.Total
      },
      {
        name: 'Foot Care Cases',
        data: card_data?.thiredGraphs?.Foot_Care_Cases
      },
      {
        name: 'Diabetic Retinopathy Cases',
        data: card_data?.thiredGraphs?.Diabetic_Retinopathy_Cases
      },
    ],
    chart: {
      type: 'bar',
      height: 350
    },
    title: {
      text: 'Region-wise: Total Cases Vs Foot Care Vs Diabetic Retinopathy',
      style: {
        fontSize:  '18px',
        fontWeight:  'bold',
        fontFamily:  undefined,
        // color:  '#6366F1'
        color:  '#000000DE'
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        barHeight: '25%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Hhohho', 'Lubombo', 'Manzini', 'Shiselweni',],
    },
    yaxis: {
      title: {
        text: 'No of Cases'
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val
        }
      }
    },
    colors:['#d2980d', '#786028', '#363445']

  };

// 4th graph
  const columnBarRegions3rd = {
    series: [
      // {
      //   name: 'Total Cases',
      //   data: [200, 250, 150, 180,]
      // },
      {
        name: 'Referred Cases',
        data: card_data?.fourthGraphs?.Total_referred_Cases
      },
      {
        name: 'Referred Foot Care Cases',
        data: card_data?.fourthGraphs?.Foot_Care_Cases
      },
      {
        name: 'Referred Diabetic Retinopathy Cases',
        data: card_data?.fourthGraphs?.Diabetic_Retinopathy_Cases
      },
    ],
    chart: {
      type: 'bar',
      height: 350
    },
    title: {
      text: 'Region-wise: Total Referred Cases Vs Referred Cases of Foot Care and Diabetic Retinopathy',
      style: {
        fontSize:  '18px',
        fontWeight:  'bold',
        fontFamily:  undefined,
        // color:  '#6366F1'
        color:  '#000000DE'
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        barHeight: '25%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Hhohho', 'Lubombo', 'Manzini', 'Shiselweni',],
    },
    yaxis: {
      title: {
        text: 'No of Cases'
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val
        }
      }
    },
    colors:['#d2980d', '#786028', '#363445']

  };


  return (
    <>
    {/* 1st row */}
    <GridAutoColumnChart>
    <ChartWrapper>
        <ReactApexChart options={options} series={series} type="bar" height={230} />
    </ChartWrapper>  

    <ChartWrapper>  
        <ReactApexChart options={options2} series={series2} type="bar" height={230} />
    </ChartWrapper>
    </GridAutoColumnChart>

    {/* 1st row END */}

    {/* 2nd row */}
    <ChartWrapper>
       <ReactApexChart options={columnBarRegions2nd} series={columnBarRegions2nd.series} type="bar" height={columnBarRegions2nd.chart.height} />
    </ChartWrapper>

    {/* 2nd row END */}

    {/* 3rd row */}

    <ChartWrapper>
       <ReactApexChart options={columnBarRegions3rd} series={columnBarRegions3rd.series} type="bar" height={columnBarRegions3rd.chart.height} />
    </ChartWrapper>

  {/* 3rd row END */}
    
  {/* 4th row */}
    <GridAutoColumnChart>
    <ChartWrapper>
        <ReactApexChart options={options4} series={series4} type="pie" height={300}/> 
    </ChartWrapper>    
    
    <ChartWrapper>
        <ReactApexChart options={options5} series={series5} type="pie" height={300}/>
    </ChartWrapper>
    </GridAutoColumnChart>
 {/* 4th row END */}


{/* 5th row */}
    <GridAutoColumnChart>
    <ChartWrapper>
        <ReactApexChart options={options9} series={series9} type="bar" height={260} />
    </ChartWrapper>  



    <ChartWrapper>  
        <ReactApexChart options={options10} series={series10} type="bar" height={260} />
    </ChartWrapper>
    </GridAutoColumnChart>
 {/* 5th row END */}
   
    </>
  )
}

export default Charts